<div class="row">
  <div class="col-xs-12 col-sm-12 col-md-8 p-0 m-0 Registration-split">
    <app-account-header [selectedHeader]="header" [tableCategory]="creditInvoice"></app-account-header>

    <div class="row">
      <div class="col-12 leftmargin">

        <h3 class="pdp-title">{{ "accountRegistration.contactsInformation.title" | cxTranslate }}</h3>
        <span class="title-sub-heading">{{ "accountRegistration.title_sub_heading" | cxTranslate }}</span>
        <div class="col-xs-12 col-sm-8 col-md-10 p0">
          <form [formGroup]="contactsForm" id="contactsAddressForm" (ngSubmit)="createAccount()">
            <div id="registerBilling">
              <div formGroupName="primaryData">
                <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                doubleLineContainer
              ">
                  <label for="primaryFirstName" class="Fields-label">{{
                    "accountRegistration.contactsInformation.firstName_label" | cxTranslate }}
                  </label>
                  <input id="firstName" name="firstName" data-valid="valid_facility" maxlength="40"
                    aria-labelledby="primaryData.firstName tooltipFacilityName" type="text" class="Fields-input"
                    formControlName="firstName" data-di-id="#primaryData.firstName" mdgTextFilter />

                  <span *ngIf="
                  !!contactsForm.get('primaryData.firstName').value &&
                  !contactsForm.get('primaryData.firstName').valid &&
                  contactsForm.get('primaryData.firstName').touched
                " class="errorMessage">{{ "accountRegistration.alpha_space_msg" | cxTranslate }}</span>
                  <span *ngIf="
                  contactsForm.get('primaryData.firstName').errors?.required &&
                  !contactsForm.get('primaryData.firstName').valid &&
                  contactsForm.get('primaryData.firstName').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                </div>

                <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                doubleLineContainer
              ">
                  <label for="primaryLastName" class="Fields-label">{{
                    "accountRegistration.contactsInformation.lastName_label" | cxTranslate }} </label>
                  <input id="lastName" name="lastName" data-valid="valid_facility" maxlength="40"
                    aria-labelledby="billingAddressForm.facilityName tooltipFacilityName" type="text"
                    class="Fields-input" formControlName="lastName" data-di-id="#billingAddressForm.facilityName" mdgTextFilter />

                  <span *ngIf="
                  !!contactsForm.get('primaryData.lastName').value &&
                  !contactsForm.get('primaryData.lastName').valid &&
                  contactsForm.get('primaryData.lastName').touched
                " class="errorMessage">{{ "accountRegistration.alpha_space_msg" | cxTranslate }}</span>
                  <span *ngIf="
                  contactsForm.get('primaryData.lastName').errors?.required &&
                  !contactsForm.get('primaryData.lastName').valid &&
                  contactsForm.get('primaryData.lastName').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                </div>

                <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                asses_dropdown
              ">
                  <label for="primaryTitle" id="contactTitleLabel" class="Fields-label">{{
                    "accountRegistration.contactsInformation.title_label" | cxTranslate }}</label>
                  <div class="">
                    <div class="">
                      <ng-select name="title" [items]="contactTitle" [searchable]="false" [clearable]="false"
                        bindLabel="name" bindValue="code" placeholder="Please select" formControlName="title"
                        class="dropdown-credit"></ng-select>
                    </div>
                    <span *ngIf="
                    contactsForm.get('primaryData.title').errors?.required &&
                    !contactsForm.get('primaryData.title').valid &&
                    contactsForm.get('primaryData.title').touched
                  " class="errorMessage drop-downs" role="alert" aria-live="assertive">{{
                      "accountRegistration.requiredMsg" | cxTranslate }}
                    </span>
                  </div>
                </div>

                <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                asses_dropdown
              ">
                  <label for="primaryRole" id="roleLabel" class="Fields-label">{{
                    "accountRegistration.contactsInformation.role_label" | cxTranslate }}</label>
                  <div class="">
                    <div class="">
                      <ng-select name="role" [items]="contactRole" [searchable]="false" [clearable]="false"
                        bindLabel="name" bindValue="code" placeholder="Please select" formControlName="role"
                        class="dropdown-credit"></ng-select>
                    </div>
                    <span *ngIf="
                    contactsForm.get('primaryData.role').errors?.required &&
                    !contactsForm.get('primaryData.role').valid &&
                    contactsForm.get('primaryData.role').touched
                  " class="errorMessage drop-downs" role="alert" aria-live="assertive">{{
                      "accountRegistration.requiredMsg" | cxTranslate }}
                    </span>
                  </div>
                </div>


                <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                doubleLineContainer
              ">
                  <label for="stateLicense" class="Fields-label">{{
                    "accountRegistration.contactsInformation.stateLicense" | cxTranslate }}

                  </label>
                  <input id="stateLicense" name="statelicense" data-valid="valid_facility"
                    aria-labelledby="accountRegistration.contactsInformation.stateLicense" maxlength="60" type="text"
                    class="Fields-input" formControlName="stateLicense" data-di-id="" mdgTextFilter />

                  <span *ngIf="
                  !!contactsForm.get('primaryData.stateLicense').value &&
                  !contactsForm.get('primaryData.stateLicense').valid &&
                  contactsForm.get('primaryData.stateLicense').touched
                " class="errorMessage">{{ "accountRegistration.alpha_space_msg" | cxTranslate }}</span>
                  <span *ngIf="
                  contactsForm.get('primaryData.stateLicense').errors?.required &&
                  !contactsForm.get('primaryData.stateLicense').valid &&
                  contactsForm.get('primaryData.stateLicense').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                </div>

                <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                doubleLineContainer
              ">
                  <label for="stateLicense" class="Fields-label">{{
                    "accountRegistration.contactsInformation.Expiration" | cxTranslate }}

                  </label>


                  <!-- <input class="Fields-input" id="datepicker" name="datepicker" placeholder="mm/dd/yyyy" [(ngModel)]="model"
                (click)="d.toggle()" data-date-format='mm/dd/yyyy' ngbDatepicker #d="ngbDatepicker"
                formControlName="datepicker" /> -->
                  <!-- <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"></button> -->
                  <!-- <input type="text" id="datepicker" name="datepicker" (keypress)="onlyNumber($event)"
                    placeholder="mm/dd/yyyy" formControlName="datepicker" class="form-control Fields-input" bsDatepicker
                    [(ngModel)]="model" [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY' }"> -->

                  <input type="tel" [appMobMask]="'date'" placeholder="mm/dd/yyyy" (focusout)="dateValidation($event)"
                    class="fieldInput" *ngIf="contactsForm" formControlName="datepicker" maxlength="10">
                  <!-- <span *ngIf="!expirationDateBoolean && !contactsForm.get('primaryData.datepicker').errors?.required"
                    class="errorMessage">{{ "accountRegistration.invalid_DATEFORMAT"
                    | cxTranslate }}</span> -->
                  <span *ngIf="prevDateForExpiration && !contactsForm.get('primaryData.datepicker').errors?.required"
                    class="errorMessage">Expiration date can't be smaller than current date</span>

                  <span *ngIf="!prevDateForExpiration &&
              !!contactsForm.get('primaryData.datepicker').value &&
              !contactsForm.get('primaryData.datepicker').valid &&
              contactsForm.get('primaryData.datepicker').touched
            " class="errorMessage">{{ "accountRegistration.invalid_DATEFORMAT" | cxTranslate }}</span>
                  <span *ngIf="
              contactsForm.get('primaryData.datepicker').errors?.required &&
              !contactsForm.get('primaryData.datepicker').valid &&
              contactsForm.get('primaryData.datepicker').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>

                </div>


                <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                doubleLineContainer
              ">
                  <label for="hin" class="Fields-label">{{
                    "accountRegistration.contactsInformation.hin" | cxTranslate }} </label>
                  <input id="hin" name="hin" data-valid="valid_facility"
                    aria-labelledby="accountRegistration.contactsInformation.hin" (keyup)="validateHIN($event)"
                    maxlength="9" type="text" class="Fields-input" onkeypress="return /[0-9a-zA-Z]/i.test(event.key)"
                    formControlName="hin" data-di-id="" mdgTextFilter/><br />
                  <span *ngIf="deaValueValidationforHIN=='notValid'" class="defaultMessage" role="alert"
                    aria-live="assertive">{{
                    "accountRegistration.invalid_dataformat" |
                    cxTranslate }}
                  </span>
                  <!-- <span *ngIf="
                  !!contactsForm.get('primaryData.lastName').value &&
                  !contactsForm.get('primaryData.lastName').valid &&
                  contactsForm.get('primaryData.lastName').touched
                " class="errorMessage">{{ "accountRegistration.special_validation_msg" | cxTranslate }}</span>
              <span *ngIf="
                  contactsForm.get('primaryData.lastName').errors?.required &&
                  !contactsForm.get('primaryData.lastName').valid &&
                  contactsForm.get('primaryData.lastName').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                cxTranslate }}
              </span> -->
                </div>

                <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                  <label for="deaf1" class="Fields-label">{{
                    "accountRegistration.contactsInformation.deaF1" | cxTranslate }} </label>
                  <input id="deaf1" name="deaf1" data-valid="valid_facility" maxlength="40"
                    aria-labelledby="accountRegistration.contactsInformation.deaF1" type="text" class="Fields-input"
                    formControlName="deaName" data-di-id="" mdgTextFilter />

                  <!-- <span *ngIf="
              !!contactsForm.get('primaryData.lastName').value &&
              !contactsForm.get('primaryData.lastName').valid &&
              contactsForm.get('primaryData.lastName').touched
            " class="errorMessage">{{ "accountRegistration.special_validation_msg" | cxTranslate }}</span>
              <span *ngIf="
              contactsForm.get('primaryData.lastName').errors?.required &&
              !contactsForm.get('primaryData.lastName').valid &&
              contactsForm.get('primaryData.lastName').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                cxTranslate }}
              </span> -->
                </div>

                <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                  <label for="deaf2" class="Fields-label">{{
                    "accountRegistration.contactsInformation.deaF2" | cxTranslate }} </label>
                  <input id="deaf2" name="deaf2" data-valid="valid_facility"
                    aria-labelledby="accountRegistration.contactsInformation.deaF2" placeholder="XXXXXXXXXXXX"
                    type="text" class="Fields-input" formControlName="dea" maxlength="9"
                    oninput="this.value = this.value.toUpperCase()" (keyup)="validatepattrn($event)"
                    data-di-id="" /><br />

                  <span *ngIf="deaValueValidation=='notValid'" class="defaultMessage" role="alert"
                    aria-live="assertive">{{
                    "accountRegistration.invalid_dataformat" |
                    cxTranslate }}
                  </span>
                  <!-- <span *ngIf="
              !!contactsForm.get('primaryData.lastName').value &&
              !contactsForm.get('primaryData.lastName').valid &&
              contactsForm.get('primaryData.lastName').touched
            " class="errorMessage">{{ "accountRegistration.special_validation_msg" | cxTranslate }}</span>
              <span *ngIf="
              contactsForm.get('primaryData.lastName').errors?.required &&
              !contactsForm.get('primaryData.lastName').valid &&
              contactsForm.get('primaryData.lastName').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                cxTranslate }}
              </span> -->
                </div>

                <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                  <label for="email" class="Fields-label">{{
                    "accountRegistration.contactsInformation.email.label" | cxTranslate }} </label>
                  <input id="email" name="email" data-valid="valid_facility" data-charsfilter="email"
                    aria-labelledby="accountRegistration.contactsInformation.email" type="text" class="Fields-input"
                    formControlName="email" data-di-id="" mdgTextFilter />

                  <span *ngIf="
              !!contactsForm.get('primaryData.email').value &&
              !contactsForm.get('primaryData.email').valid &&
              contactsForm.get('primaryData.email').touched
            " class="errorMessage">{{ "accountRegistration.form.email.email_validation_msg" | cxTranslate }}</span>
                  <span *ngIf="
              contactsForm.get('primaryData.email').errors?.required &&
              !contactsForm.get('primaryData.email').valid &&
              contactsForm.get('primaryData.email').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                </div>

                <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                  <label for="confirmemail" class="Fields-label">{{
                    "accountRegistration.contactsInformation.confirm_email.label" | cxTranslate }} </label>
                  <input id="confirmEmail" name="confirmemail" data-valid="valid_facility" data-charsfilter="email"
                    aria-labelledby="accountRegistration.contactsInformation.confirmemail" type="text"
                    class="Fields-input" formControlName="confirmEmail" data-di-id="" mdgTextFilter />

                  <span *ngIf="
                !!contactsForm.get('primaryData.confirmEmail').value &&
                !contactsForm.get('primaryData.confirmEmail').invalid &&
                contactsForm.get('primaryData.confirmEmail').value !==
                contactsForm.get('primaryData.email').value
              " class="errorMessage">{{
                    "accountRegistration.form.confirm_email.email_not_match"
                    | cxTranslate
                    }}</span>


                  <span *ngIf="
              !!contactsForm.get('primaryData.confirmEmail').value &&
              !contactsForm.get('primaryData.confirmEmail').valid &&
              contactsForm.get('primaryData.confirmEmail').touched
            " class="errorMessage">{{ "accountRegistration.form.email.email_validation_msg" | cxTranslate }}</span>
                  <span *ngIf="
              contactsForm.get('primaryData.confirmEmail').errors?.required &&
              !contactsForm.get('primaryData.confirmEmail').valid &&
              contactsForm.get('primaryData.confirmEmail').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container small-device">
                  <div class="phone-extension">
                    <div class="phone-container">
                      <label for="phone" class="Fields-label">{{
                        "accountRegistration.contactsInformation.phone.label" | cxTranslate }}
                        <span>{{
                          "accountRegistration.optional_tag" | cxTranslate
                          }}</span>
                      </label>
                      <input id="phone" name="phone" data-valid="valid_phone" placeholder="123-456-7890" maxlength="12"
                        appPhoneMask type="text" class="Fields-input phone-no-mask" formControlName="phone"
                        autocomplete="off" data-di-id="#formPhone"  />

                      <span *ngIf="
                  !!contactsForm.get('primaryData.phone').value &&
                  !contactsForm.get('primaryData.phone').valid &&
                  contactsForm.get('primaryData.phone').touched
                " class="errorMessage">{{ "accountRegistration.form.phone.ph_validation_msg" | cxTranslate }}</span>
                      <span *ngIf="
                  contactsForm.get('primaryData.phone').errors?.required &&
                  !contactsForm.get('primaryData.phone').valid &&
                  contactsForm.get('primaryData.phone').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                        cxTranslate }}
                      </span>
                    </div>


                    <div class="phone-container doubleLineContainer">
                      <label for="extension" class="Fields-label">{{
                        "accountRegistration.contactsInformation.extension.label" | cxTranslate }}
                        <span>{{
                          "accountRegistration.optional_tag" | cxTranslate
                          }}</span>
                      </label>
                      <input id="extension" name="extension" data-valid="valid_facility"
                        aria-labelledby="accountRegistration.contactsInformation.extension" type="text"
                        class="Fields-input" formControlName="extension" placeholder="-" data-di-id="" />

                      <!-- <span *ngIf="
                  !!contactsForm.get('primaryData.extension').value &&
                  !contactsForm.get('primaryData.extension').valid &&
                  contactsForm.get('primaryData.extension').touched
                " class="errorMessage">{{ "accountRegistration.special_validation_msg" | cxTranslate }}</span>
                  <span *ngIf="
                  contactsForm.get('primaryData.extension').errors?.required &&
                  !contactsForm.get('primaryData.extension').valid &&
                  contactsForm.get('primaryData.extension').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span> -->
                    </div>


                  </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                  <re-captcha formControlName="captcha" (resolved)="showCaptchaErrorMsg = false"></re-captcha>
  
                  <span *ngIf="showCaptchaErrorMsg" class="defaultMessage" role="alert" aria-live="assertive">{{
                        "accountRegistration.requiredMsg" |
                        cxTranslate }}
                  </span>
                  </div>

                <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          " style="display:none;">
                  <label for="shippingAddressForm.shippingAddress" id="shippingAddress" class="Fields-label-new">{{
                    "accountRegistration.primary_office_contact.is_office_contact"
                    | cxTranslate
                    }}</label>
                  <div class="custom-control custom-radio radio_grp label-location">
                    <input type="radio" id="shippingAddressForm.shippingAddress1" class="" [value]="true" checked
                      (click)="replicateForm('Y')" />
                    <label class="ctClassForLabel secloct" for="shippingAddressForm.shippingAddress1">
                      <!-- {{
                  "accountRegistration.form.yellow_fever.accepted" | cxTranslate
                  }} -->
                      Yes
                    </label>
                  </div>
                  <div class="custom-control custom-radio radio_grp label-location">
                    <input type="radio" id="shippingAddressForm.shippingAddress2" class="" [value]="false"
                      (click)="replicateForm('N')" />
                    <label class="ctClassForLabel" for="shippingAddressForm.shippingAddress2">
                      <!-- {{
                  "accountRegistration.form.yellow_fever.rejected"
                  | cxTranslate
                  }} -->No
                    </label>
                  </div>

                  <!-- <span *ngIf="
                  contactsForm.get('primaryData.sameAsBillingAddress').errors?.required &&
                  !contactsForm.get('primaryData.sameAsBillingAddress').valid &&
                  contactsForm.get('primaryData.sameAsBillingAddress').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                cxTranslate }}
              </span> -->
                </div>


                <div *ngIf="!isPrimaryFlag">


                  <div class="
              col-xs-12 col-sm-12 col-md-12
              p0
              Fields-container
              doubleLineContainer
            ">


                    <ng-template #errorPopContent>{{
                      "accountRegistration.special_validation_msg_popover" | cxTranslate
                      }}</ng-template>

                    <label for="facilityName" class="Fields-label icon-label">{{
                      "accountRegistration.contactsInformation.firstName_label"
                      |
                      cxTranslate }}
                    </label>
                    <!-- <a placement="top" [ngbPopover]="errorPopContent"><img src="../../../../assets/icons/faqs-plum.svg"
                    alt="faq_reg" class="faq" /></a> -->
                    <input id="firstName_repeat" name="firstName_repeat" required data-valid="valid_facility"
                      aria-labelledby="primaryData.firstName_repeat tooltipFacilityName" type="text" maxlength="40"
                      class="Fields-input" formControlName="firstName_repeat"
                      data-di-id="#primaryData.firstName_repeat" mdgTextFilter />

                    <span *ngIf="
                !!contactsForm.get('primaryData.firstName_repeat').value &&
                !contactsForm.get('primaryData.firstName_repeat').valid &&
                contactsForm.get('primaryData.firstName_repeat').touched
              " class="errorMessage">{{
                      "accountRegistration.alpha_numeric_msg" | cxTranslate
                      }}</span>
                    <span *ngIf="
                contactsForm.get('primaryData.firstName_repeat').errors
                  ?.required &&
                !contactsForm.get('primaryData.firstName_repeat').valid &&
                contactsForm.get('primaryData.firstName_repeat').touched
              " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>
                  </div>

                  <div class="
              col-xs-12 col-sm-12 col-md-12
              p0
              Fields-container
              doubleLineContainer
            ">


                    <ng-template #errorPopContent>{{
                      "accountRegistration.special_validation_msg_popover" | cxTranslate
                      }}</ng-template>

                    <label for="facilityName" class="Fields-label icon-label">{{
                      "accountRegistration.contactsInformation.lastName_label"
                      |
                      cxTranslate }}
                    </label>
                    <!-- <a placement="top" [ngbPopover]="errorPopContent"><img src="../../../../assets/icons/faqs-plum.svg"
                    alt="faq_reg" class="faq" /></a> -->
                    <input id="lastname_repeat" name="lastname_repeat" required data-valid="valid_facility" maxlength="40"
                      aria-labelledby="primaryData.lastname_repeat tooltipFacilityName" type="text" class="Fields-input"
                      formControlName="lastname_repeat" data-di-id="#primaryData.lastname_repeat" mdgTextFilter />

                    <span *ngIf="
                !!contactsForm.get('primaryData.lastname_repeat').value &&
                !contactsForm.get('primaryData.lastname_repeat').valid &&
                contactsForm.get('primaryData.lastname_repeat').touched
              " class="errorMessage">{{
                      "accountRegistration.alpha_numeric_msg" | cxTranslate
                      }}</span>
                    <span *ngIf="
                contactsForm.get('primaryData.lastname_repeat').errors
                  ?.required &&
                !contactsForm.get('primaryData.lastname_repeat').valid &&
                contactsForm.get('primaryData.lastname_repeat').touched
              " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>
                  </div>


                  <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                asses_dropdown
              ">
                    <label for="primaryTitle" id="contactTitleLabel" class="Fields-label">{{
                      "accountRegistration.contactsInformation.title_label" | cxTranslate }}</label>
                    <div class="">
                      <div class="">
                        <ng-select name="title_repeat" [items]="contactTitle" [searchable]="false" [clearable]="false"
                          bindLabel="name" bindValue="code" placeholder="Please select" formControlName="title_repeat"
                          class="dropdown-credit"></ng-select>
                      </div>
                      <span *ngIf="
                    contactsForm.get('primaryData.title_repeat').errors?.required &&
                    !contactsForm.get('primaryData.title_repeat').valid &&
                    contactsForm.get('primaryData.title_repeat').touched
                  " class="errorMessage drop-downs" role="alert" aria-live="assertive">{{
                        "accountRegistration.requiredMsg" | cxTranslate }}
                      </span>
                    </div>
                  </div>


                  <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            asses_dropdown
          ">
                    <label for="primaryRole" id="roleLabel" class="Fields-label">{{
                      "accountRegistration.contactsInformation.role_label" | cxTranslate }}</label>
                    <div class="">
                      <div class="">
                        <ng-select name="role_repeat" [items]="contactRole" [searchable]="false" [clearable]="false"
                          bindLabel="name" bindValue="code" placeholder="Please select" formControlName="role_repeat"
                          class="dropdown-credit"></ng-select>
                      </div>
                      <span *ngIf="
                contactsForm.get('primaryData.role_repeat').errors?.required &&
                !contactsForm.get('primaryData.role_repeat').valid &&
                contactsForm.get('primaryData.role_repeat').touched
              " class="errorMessage drop-downs" role="alert" aria-live="assertive">{{
                        "accountRegistration.requiredMsg" | cxTranslate }}
                      </span>
                    </div>
                  </div>


                  <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                    <label for="stateLicense" class="Fields-label">{{
                      "accountRegistration.contactsInformation.stateLicense" | cxTranslate }}
                      <span>{{
                        "accountRegistration.optional_tag" | cxTranslate
                        }}</span>
                    </label>
                    <input id="stateLicense_repeat" name="statelicense_repeat" data-valid="valid_facility"
                      aria-labelledby="accountRegistration.contactsInformation.stateLicense" type="text"
                      class="Fields-input" formControlName="stateLicense_repeat" data-di-id="" mdgTextFilter />

                    <span *ngIf="
              !!contactsForm.get('primaryData.stateLicense_repeat').value &&
              !contactsForm.get('primaryData.stateLicense_repeat').valid &&
              contactsForm.get('primaryData.stateLicense_repeat').touched
            " class="errorMessage">{{ "accountRegistration.alpha_space_msg" | cxTranslate }}</span>
                    <span *ngIf="
              contactsForm.get('primaryData.stateLicense_repeat').errors?.required &&
              !contactsForm.get('primaryData.stateLicense_repeat').valid &&
              contactsForm.get('primaryData.stateLicense_repeat').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>
                  </div>

                  <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                    <label for="stateLicense" class="Fields-label">{{
                      "accountRegistration.contactsInformation.Expiration" | cxTranslate }}
                      <span>{{
                        "accountRegistration.optional_tag" | cxTranslate
                        }}</span>
                    </label>
                    <!-- <input type="text" placeholder="{{ 'ordersList.dateFormat' | cxTranslate }}" class="input-filter"
            [(ngModel)]="fromDate" (ngModelChange)="validateDate()" bsDatepicker /> -->

                    <input class="Fields-input" id="datepicker_repeat" name="datepicker_repeat" placeholder="mm/dd/yyyy"
                      [(ngModel)]="model2" (click)="d.toggle()" ngbDatepicker #d="ngbDatepicker"
                      formControlName="datepicker_repeat" />
                    <!-- <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"></button> -->
                    <span *ngIf="
          !!contactsForm.get('primaryData.datepicker_repeat').value &&
          !contactsForm.get('primaryData.datepicker_repeat').valid &&
          contactsForm.get('primaryData.datepicker_repeat').touched
        " class="errorMessage">{{ "accountRegistration.invalid_DATEFORMAT" | cxTranslate }}</span>
                    <span *ngIf="
          contactsForm.get('primaryData.datepicker_repeat').errors?.required &&
          !contactsForm.get('primaryData.datepicker_repeat').valid &&
          contactsForm.get('primaryData.datepicker_repeat').touched
        " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>

                  </div>


                  <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                    <label for="hin" class="Fields-label">{{
                      "accountRegistration.contactsInformation.hin" | cxTranslate }} </label>
                    <input id="hin_repeat" name="hin_repeat" data-valid="valid_facility"
                      aria-labelledby="accountRegistration.contactsInformation.hin" type="text" class="Fields-input"
                      formControlName="hin_repeat" data-di-id="" mdgTextFilter />

                    <!-- <span *ngIf="
              !!contactsForm.get('primaryData.lastName').value &&
              !contactsForm.get('primaryData.lastName').valid &&
              contactsForm.get('primaryData.lastName').touched
            " class="errorMessage">{{ "accountRegistration.special_validation_msg" | cxTranslate }}</span>
          <span *ngIf="
              contactsForm.get('primaryData.lastName').errors?.required &&
              !contactsForm.get('primaryData.lastName').valid &&
              contactsForm.get('primaryData.lastName').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
            cxTranslate }}
          </span> -->
                  </div>

                  <div class="
        col-xs-12 col-sm-12 col-md-12
        p0
        Fields-container
        doubleLineContainer
      ">
                    <label for="deaf1" class="Fields-label">{{
                      "accountRegistration.contactsInformation.deaF1" | cxTranslate }} </label>
                    <input id="deaf1_repeat" name="deaf1_repeat" data-valid="valid_facility" maxlength="40"
                      aria-labelledby="accountRegistration.contactsInformation.deaF1" type="text" class="Fields-input"
                      formControlName="deaName_repeat" data-di-id="" mdgTextFilter />

                    <!-- <span *ngIf="
          !!contactsForm.get('primaryData.lastName').value &&
          !contactsForm.get('primaryData.lastName').valid &&
          contactsForm.get('primaryData.lastName').touched
        " class="errorMessage">{{ "accountRegistration.special_validation_msg" | cxTranslate }}</span>
          <span *ngIf="
          contactsForm.get('primaryData.lastName').errors?.required &&
          !contactsForm.get('primaryData.lastName').valid &&
          contactsForm.get('primaryData.lastName').touched
        " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
            cxTranslate }}
          </span> -->
                  </div>

                  <div class="
        col-xs-12 col-sm-12 col-md-12
        p0
        Fields-container
        doubleLineContainer
      ">
                    <label for="deaf2" class="Fields-label">{{
                      "accountRegistration.contactsInformation.deaF2" | cxTranslate }} </label>
                    <input id="dea_repeat" name="dea_repeat" data-valid="valid_facility"
                      aria-labelledby="accountRegistration.contactsInformation.deaF2" placeholder="XXXXXXXXXXXX"
                      type="text" class="Fields-input" formControlName="dea_repeat" data-di-id="" />

                    <!-- <span *ngIf="
          !!contactsForm.get('primaryData.lastName').value &&
          !contactsForm.get('primaryData.lastName').valid &&
          contactsForm.get('primaryData.lastName').touched
        " class="errorMessage">{{ "accountRegistration.special_validation_msg" | cxTranslate }}</span>
          <span *ngIf="
          contactsForm.get('primaryData.lastName').errors?.required &&
          !contactsForm.get('primaryData.lastName').valid &&
          contactsForm.get('primaryData.lastName').touched
        " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
            cxTranslate }}
          </span> -->
                  </div>

                  <div class="
        col-xs-12 col-sm-12 col-md-12
        p0
        Fields-container
        doubleLineContainer
      ">
                    <label for="email" class="Fields-label">{{
                      "accountRegistration.contactsInformation.email.label" | cxTranslate }} </label>
                    <input id="email_repeat" name="email_repeat" data-valid="valid_facility"
                      aria-labelledby="accountRegistration.contactsInformation.email" type="text" class="Fields-input"
                      formControlName="email_repeat" data-di-id="" mdgTextFilter />

                    <span *ngIf="
          !!contactsForm.get('primaryData.email_repeat').value &&
          !contactsForm.get('primaryData.email_repeat').valid &&
          contactsForm.get('primaryData.email_repeat').touched
        " class="errorMessage">{{ "accountRegistration.form.email.email_validation_msg" | cxTranslate }}</span>
                    <span *ngIf="
          contactsForm.get('primaryData.email_repeat').errors?.required &&
          !contactsForm.get('primaryData.email_repeat').valid &&
          contactsForm.get('primaryData.email_repeat').touched
        " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>
                  </div>

                  <div class="
        col-xs-12 col-sm-12 col-md-12
        p0
        Fields-container
        doubleLineContainer
      ">
                    <label for="confirmemail" class="Fields-label">{{
                      "accountRegistration.contactsInformation.confirm_email.label" | cxTranslate }} </label>
                    <input id="confirmEmail_repeat" name="confirmemail_repeat" data-valid="valid_facility"
                      aria-labelledby="accountRegistration.contactsInformation.confirmemail" type="text"
                      class="Fields-input" formControlName="confirmEmail_repeat" data-di-id="" mdgTextFilter />

                    <span *ngIf="
            !!contactsForm.get('primaryData.confirmEmail_repeat').value &&
            !contactsForm.get('primaryData.confirmEmail_repeat').invalid &&
            contactsForm.get('primaryData.confirmEmail_repeat').value !==
            contactsForm.get('primaryData.email_repeat').value
          " class="errorMessage">{{
                      "accountRegistration.form.confirm_email.email_not_match"
                      | cxTranslate
                      }}</span>


                    <span *ngIf="
          !!contactsForm.get('primaryData.confirmEmail_repeat').value &&
          !contactsForm.get('primaryData.confirmEmail_repeat').valid &&
          contactsForm.get('primaryData.confirmEmail_repeat').touched
        " class="errorMessage">{{ "accountRegistration.form.email.email_validation_msg" | cxTranslate }}</span>
                    <span *ngIf="
          contactsForm.get('primaryData.confirmEmail_repeat').errors?.required &&
          !contactsForm.get('primaryData.confirmEmail_repeat').valid &&
          contactsForm.get('primaryData.confirmEmail_repeat').touched
        " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>
                  </div>






                </div>







                <!-- <div
              class="container col-xs-12 col-sm-12 col-md-12 p0 Fields-container"
            >
              <label
                for="preferredContact"
                id="preferredContactLabel"
                class="Fields-label"
                >{{ "accountRegistration.contactsInformation.preferred_contact_label" | cxTranslate }}</label
              >
              <div class="" id="preferredContactEmail">
                <label
                  for="contactInfoForm0.email"
                  class="Fields-label mt0 res_lab"
                >
                {{ "accountRegistration.form.email.label" | cxTranslate }}
                </label>
                <div
                  class="
                    custom-control custom-radio custom-control-inline
                    radio_grp
                    label-location
                    ptl
                  "
                >
                  <input
                    type="radio"
                    id="preferredEmail"
                    name="preferredContactMethod"
                    class="custom-control-input"
                    [value]="preferredContactMethod[0]"
                    formControlName="preferredContactMethod"
                  />
                  <label
                    class="custom-control-label secloct"
                    for="preferredEmail"
                  >
                  </label>
                  <div style="display: inline">
                    <input
                      id="primaryEmail"
                      name="email"
                      data-valid="valid_mail"
                      type="text"
                      class="Fields-input contact-email"
                      data-view="newemail"
                      formControlName="email"
                      data-di-id="primaryEmail"
                    />
                    <span
                      *ngIf="
                        !!contactsForm.get('primaryData.email').value &&
                        !contactsForm.get('primaryData.email').valid &&
                        contactsForm.get('primaryData.email').touched
                      "
                      class="errorMessage contacts"
                    >
                    {{ "accountRegistration.form.email.email_validation_msg" | cxTranslate }}
                    </span>
                    <span
                      *ngIf="
                        contactsForm.get('primaryData.email').errors?.required &&
                        !contactsForm.get('primaryData.email').valid &&
                        contactsForm.get('primaryData.email').touched
                      "
                      class="errorMessage contacts"
                      >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                    </span>
                  </div>
                </div>             
              </div>
              <div class="" id="preferredContactFax">
                <label
                  for="contactInfoForm0.fax"
                  class="Fields-label mt0 res_lab"
                >
                  {{ "accountRegistration.contactsInformation.fax_label" | cxTranslate }}
                </label>
                <div
                  class="
                    custom-control custom-radio custom-control-inline
                    radio_grp
                    label-location
                    ptl
                  "
                >
                  <input
                    type="radio"
                    id="primaryFax"
                    name="preferredContactMethod"
                    class="custom-control-input"
                    [value]="preferredContactMethod[1]"
                    formControlName="preferredContactMethod"
                  />
                  <label class="custom-control-label secloct" for="primaryFax">
                  </label>
                  <div style="display: inline">
                    <input
                      id="primaryFaxp"
                      name="fax"
                      data-valid="valid_fax"
                      placeholder="xxx-xxx-xxxx"
                      type="text"
                      class="Fields-input contact-email"
                      data-view="newfax"
                      formControlName="fax"
                      maxlength="12"
                      appPhoneMask
                      data-di-id="#contactInfoForm0.fax"
                    />
                    <span
                      *ngIf="                      
                        !!contactsForm.get('primaryData.fax').value &&
                        !contactsForm.get('primaryData.fax').valid &&
                        contactsForm.get('primaryData.fax').touched
                      "
                      class="errorMessage contacts"
                    >
                    {{ "accountRegistration.form.office_fax.fax_validation_msg" | cxTranslate }}
                    </span>
                    <span
                      *ngIf="
                        contactsForm.get('primaryData.fax').errors?.required &&
                        !contactsForm.get('primaryData.fax').valid &&
                        contactsForm.get('primaryData.fax').touched
                      "
                      class="errorMessage contacts"
                      >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                    </span>
                  </div>
                </div>
              </div>
            </div> -->

                <!-- <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
              <label for="primaryPhone" class="Fields-label"
                >{{ "accountRegistration.form.phone.label" | cxTranslate }}<span>{{ "accountRegistration.optional_tag" | cxTranslate }}</span></label
              >
              <input
                id="primaryPhone"
                name="phone"
                data-valid="valid_phone"
                placeholder="xxx-xxx-xxxx"
                type="text"
                maxlength="12"
                appPhoneMask
                class="Fields-input phone-no-mask field-optional"
                formControlName="phone"
                data-di-id="primaryPhone"
              />
  
              <span
                class="errorMessage"
                *ngIf="
                  !!contactsForm.get('primaryData.phone').value &&
                  !contactsForm.get('primaryData.phone').valid &&
                  contactsForm.get('primaryData.phone').touched
                "
                >{{ "accountRegistration.form.phone.ph_validation_msg" | cxTranslate }}</span
              >
            </div> -->
              </div>

              <!-- New Section starts-->

              <!-- <div class="col-xs-12 col-sm-12 col-md-12 p0 acc_bg par_data">
            <label class="field-check">
              <input
                id="pr-data"
                name="invoiceContact"
                type="checkbox"
                value="false"
                formControlName="invoiceContact"
                data-di-id="#pr-data"
              />
            </label>
            <span class="check-text"
              ><b>{{ "accountRegistration.contactsInformation.invoice_address_label" | cxTranslate }}</b>
              {{ "accountRegistration.optional_tag" | cxTranslate }}</span
            >
            <div
              formGroupName="invoiceNewContactData"
              *ngIf="contactsForm.get('invoiceContact').value"
            >
              <div>
                <label
                  for="invoiceRecipientContact"
                  id="invoiceRecipient"
                  class="Fields-label"
                  >{{ "accountRegistration.contactsInformation.recipient_label" | cxTranslate }}</label
                >
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    id="primaryContact"
                    name="primaryContact2"
                    [value]="isPrimaryContact[0]"
                    formControlName="primaryContact2"
                  />
                  <label
                    class="custom-control-label radio_align"
                    for="primaryContact"
                    >{{ "accountRegistration.contactsInformation.primary_cont_label" | cxTranslate }}</label
                  >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    id="newContact"
                    name="primaryContact2"
                    [value]="isPrimaryContact[1]"
                    formControlName="primaryContact2"
                  />
                  <label class="custom-control-label radio_align" for="newContact"
                    >{{ "accountRegistration.contactsInformation.new_cont_label" | cxTranslate }}</label
                  >
                </div>
              </div>
  
              <div
                id="registerBilling" class="billing-section"
                *ngIf="
                  !contactsForm.get('invoiceNewContactData.primaryContact2')
                    .value && contactsForm.get('invoiceContact').value
                "
              >
                <div
                  class="
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                    doubleLineContainer
                  "
                >
                  <label for="primaryFirstName" class="Fields-label"
                    >{{ "accountRegistration.contactsInformation.firstName_label" | cxTranslate }}
                  </label>
                  <input
                    id="primaryFirstName"
                    name="firstName"
                    data-valid="valid_facility"
                    aria-labelledby="billingForm.firstName tooltipFacilityName"
                    type="text"
                    class="Fields-input"
                    formControlName="firstName"
                    data-di-id="#billingForm.firstName"
                  />
                  <span
                    *ngIf="
                      !!contactsForm.get('invoiceNewContactData.firstName')
                        .value &&
                      !contactsForm.get('invoiceNewContactData.firstName')
                        .valid &&
                      contactsForm.get('invoiceNewContactData.firstName').touched
                    "
                    class="errorMessage"
                    >{{ "accountRegistration.special_validation_msg" | cxTranslate }}</span
                  >
                  <span
                    *ngIf="
                      contactsForm.get('invoiceNewContactData.firstName').errors
                        ?.required &&
                      !contactsForm.get('invoiceNewContactData.firstName')
                        .valid &&
                      contactsForm.get('invoiceNewContactData.firstName').touched
                    "
                    class="defaultMessage"
                    role="alert"
                    aria-live="assertive"
                    >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                  </span>
                </div>
  
                <div
                  class="
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                    doubleLineContainer
                  "
                >
                  <label for="formLastName" class="Fields-label"
                    >{{ "accountRegistration.contactsInformation.lastName_label" | cxTranslate }}
                  </label>
                  <input
                    id="formLastName"
                    name="lastName"
                    data-valid="valid_facility"
                    type="text"
                    class="Fields-input"
                    formControlName="lastName"
                    autocomplete="off"
                    data-di-id="#formLastName"
                  />
  
                  <span
                    *ngIf="
                      !!contactsForm.get('invoiceNewContactData.lastName')
                        .value &&
                      !contactsForm.get('invoiceNewContactData.lastName').valid &&
                      contactsForm.get('invoiceNewContactData.lastName').touched
                    "
                    class="errorMessage"
                    >{{ "accountRegistration.special_validation_msg" | cxTranslate }}</span
                  >
                  <span
                    *ngIf="
                      contactsForm.get('invoiceNewContactData.lastName').errors
                        ?.required &&
                      !contactsForm.get('invoiceNewContactData.lastName').valid &&
                      contactsForm.get('invoiceNewContactData.lastName').touched
                    "
                    class="defaultMessage"
                    role="alert"
                    aria-live="assertive"
                    >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                  </span>
                </div>
                <div
                  class="
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                    asses_dropdown
                  "
                >
                  <label for="formTitle" id="formTitleLabel" class="Fields-label"
                    >{{ "accountRegistration.contactsInformation.title_label" | cxTranslate }}</label
                  >
                  <div class="">
                    <div class="">
                      <ng-select
                        name="title"
                        [items]="contactTitle"
                        [searchable]="false"
                        [clearable]="false"
                        bindLabel="name"
                        bindValue="code"
                        placeholder="Please select"
                        formControlName="title"
                        class="dropdown-credit"
                      ></ng-select>
                    </div>
                    <span
                      *ngIf="
                        contactsForm.get('invoiceNewContactData.title').errors
                          ?.required &&
                        !contactsForm.get('invoiceNewContactData.title').valid &&
                        contactsForm.get('invoiceNewContactData.title').touched
                      "
                      class="errorMessage drop-downs"
                      role="alert"
                      aria-live="assertive"
                      >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                    </span>
                  </div>
                </div>
  
                <div
                  class="
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                    asses_dropdown
                  "
                >
                  <label
                    for="formUserRole"
                    id="formUserRoleLabel"
                    class="Fields-label"
                    >{{ "accountRegistration.contactsInformation.role_label" | cxTranslate }}</label
                  >
                  <div class="">
                    <div class="">
                      <ng-select
                        name="role"
                        [items]="contactRole"
                        [searchable]="false"
                        [clearable]="false"
                        bindLabel="name"
                        bindValue="code"
                        placeholder="Please select"
                        formControlName="role"
                        class="dropdown-credit"
                      ></ng-select>
                    </div>
                    <span
                      *ngIf="
                        contactsForm.get('invoiceNewContactData.role').errors
                          ?.required &&
                        !contactsForm.get('invoiceNewContactData.role').valid &&
                        contactsForm.get('invoiceNewContactData.role').touched
                      "
                      class="errorMessage drop-downs"
                      role="alert"
                      aria-live="assertive"
                      >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                    </span>
                  </div>
                </div>
  
                <div
                  class="
                    container
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                  "
                >
                  <label
                    for="preferredContactInvoices"
                    id="preferredContactInvoicesLabel"
                    class="Fields-label"
                    >{{ "accountRegistration.contactsInformation.preferred_contact_label" | cxTranslate }}</label
                  >
                  <div class="" id="preferredContactEmailInvoices">
                    <label
                      for="contactInfoForm0.email"
                      class="Fields-label mt0 res_lab"
                    >
                      {{ "accountRegistration.form.email.label" | cxTranslate }}
                    </label>
                    <div
                      class="
                        custom-control custom-radio custom-control-inline
                        radio_grp
                        label-location
                        ptl
                      "
                    >
                      <input
                        type="radio"
                        id="preferredEmailInvoices"
                        name="preferredContactMethod2"
                        class="custom-control-input"
                        [value]="preferredContactMethod[0]"
                        formControlName="preferredContactMethod2"
                      />
                      <label
                        class="custom-control-label secloct"
                        for="preferredEmailInvoices"
                      >
                      </label>
                      <div style="display: inline">
                        <input
                          id="primaryEmailInvoice"
                          name="email"
                          data-valid="valid_mail"
                          type="text"
                          class="Fields-input contact-email"
                          data-view="newemail"
                          formControlName="email"
                          data-di-id="primaryEmailInvoice"
                        />
                        <span
                          *ngIf="                          
                            !!contactsForm.get('invoiceNewContactData.email')
                              .value &&
                            !contactsForm.get('invoiceNewContactData.email')
                              .valid &&
                            contactsForm.get('invoiceNewContactData.email')
                              .touched
                          "
                          class="errorMessage contacts"
                        >
                          {{ "accountRegistration.form.email.email_validation_msg" | cxTranslate }}
                        </span>
                        <span
                          *ngIf="
                            contactsForm.get('invoiceNewContactData.email').errors
                              ?.required &&
                            !contactsForm.get('invoiceNewContactData.email')
                              .valid &&
                            contactsForm.get('invoiceNewContactData.email')
                              .touched
                          "
                          class="errorMessage contacts"
                          >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="" id="preferredContactFaxInvoices">
                    <label
                      for="contactInfoForm0.fax"
                      class="Fields-label mt0 res_lab"
                    >
                      {{ "accountRegistration.contactsInformation.fax_label" | cxTranslate }}
                    </label>
                    <div
                      class="
                        custom-control custom-radio custom-control-inline
                        radio_grp
                        label-location
                        ptl
                      "
                    >
                      <input
                        type="radio"
                        id="preferredFaxInvoices"
                        name="preferredContactMethod2"
                        class="custom-control-input"
                        [value]="preferredContactMethod[1]"
                        formControlName="preferredContactMethod2"
                      />
                      <label
                        class="custom-control-label secloct"
                        for="preferredFaxInvoices"
                      >
                      </label>
                      <div style="display: inline">
                        <input
                          id="preferredFaxInvoice"
                          name="fax"
                          data-valid="valid_fax"
                          placeholder="xxx-xxx-xxxx"
                          type="text"
                          class="Fields-input contact-email"
                          data-view="newfax"
                          formControlName="fax"
                          appPhoneMask
                          maxlength="12"
                          data-di-id="#contactInfoForm0.fax"
                        />
                        <span
                          *ngIf="                          
                            !!contactsForm.get('invoiceNewContactData.fax')
                              .value &&
                            !contactsForm.get('invoiceNewContactData.fax')
                              .valid &&
                            contactsForm.get('invoiceNewContactData.fax').touched
                          "
                          class="errorMessage contacts"
                        >
                        {{ "accountRegistration.form.office_fax.fax_validation_msg" | cxTranslate }}
                        </span>
                        <span
                          *ngIf="
                            contactsForm.get('invoiceNewContactData.fax').errors
                              ?.required &&
                            !contactsForm.get('invoiceNewContactData.fax')
                              .valid &&
                            contactsForm.get('invoiceNewContactData.fax').touched
                          "
                          class="errorMessage contacts"
                          >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                  <label for="invoicePhone" class="Fields-label"
                    >{{ "accountRegistration.form.phone.label" | cxTranslate }}<span>{{ "accountRegistration.optional_tag" | cxTranslate }}</span></label
                  >
                  <input
                    id="invoicePhone"
                    name="phone"
                    data-valid="valid_phone"
                    placeholder="xxx-xxx-xxxx"
                    type="text"
                    maxlength="12"
                    appPhoneMask
                    class="Fields-input phone-no-mask field-optional"
                    formControlName="phone"
                    data-di-id="invoicePhone"
                  />
  
                  <span
                    class="errorMessage"
                    *ngIf="
                      !!contactsForm.get('invoiceNewContactData.phone').value &&
                      !contactsForm.get('invoiceNewContactData.phone').valid &&
                      contactsForm.get('invoiceNewContactData.phone').touched
                    "
                    >{{ "accountRegistration.form.phone.ph_validation_msg" | cxTranslate }}</span
                  >
                </div>
              </div>
            </div>
          </div> -->

              <!-- New Section ends-->

              <!-- Other New Section Starts -->
              <!-- <div class="col-xs-12 col-sm-12 col-md-12 p0 acc_bg acc_shipping">
            <label class="field-check">
              <input
                id="new-pr-data"
                name="shippingContact"
                type="checkbox"
                value="false"
                formControlName="shippingContact"
                data-di-id="#new-pr-data"
              />
            </label>
            <span class="check-text"
              ><b>{{ "accountRegistration.contactsInformation.shipping_address_label" | cxTranslate }}</b>
              {{ "accountRegistration.optional_tag" | cxTranslate }}</span
            >
            <div
              formGroupName="shippingNewContactData"
              *ngIf="contactsForm.get('shippingContact').value"
            >
              <div>
                <label
                  for="shippingRecipientContact"
                  id="shippingRecipient"
                  class="Fields-label"
                  >{{ "accountRegistration.contactsInformation.recipient_label" | cxTranslate }}</label
                >
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    id="primaryContact2"
                    name="primaryContact3"
                    [value]="isPrimaryContact[0]"
                    formControlName="primaryContact3"
                  />
                  <label
                    class="custom-control-label radio_align"
                    for="primaryContact2"
                    >{{ "accountRegistration.contactsInformation.primary_cont_label" | cxTranslate }}</label
                  >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    id="newContact2"
                    name="primaryContact3"
                    [value]="isPrimaryContact[1]"
                    formControlName="primaryContact3"
                  />
                  <label
                    class="custom-control-label radio_align"
                    for="newContact2"
                    >{{ "accountRegistration.contactsInformation.new_cont_label" | cxTranslate }}</label
                  >
                </div>
              </div>
              <div id="registerBilling" class="billing-section" *ngIf="
                              !contactsForm.get('shippingNewContactData.primaryContact3')
                                .value && contactsForm.get('shippingContact').value
                            ">
                <div
                  class="
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                    doubleLineContainer
                  "
                >
                  <label for="formFirstNameShipping" class="Fields-label"
                    >{{ "accountRegistration.contactsInformation.firstName_label" | cxTranslate }}
                  </label>
                  <input
                    id="formFirstNameShipping"
                    name="firstName"
                    data-valid="valid_facility"
                    aria-labelledby="formFirstNameShipping tooltipFacilityName"
                    type="text"
                    class="Fields-input"
                    formControlName="firstName"
                    data-di-id="#formFirstNameShipping"
                  />
                  <span
                    *ngIf="
                      !!contactsForm.get('shippingNewContactData.firstName')
                        .value &&
                      !contactsForm.get('shippingNewContactData.firstName')
                        .valid &&
                      contactsForm.get('shippingNewContactData.firstName').touched
                    "
                    class="errorMessage"
                    >{{ "accountRegistration.special_validation_msg" | cxTranslate }}</span
                  >
                  <span
                    *ngIf="
                      contactsForm.get('shippingNewContactData.firstName').errors
                        ?.required &&
                      !contactsForm.get('shippingNewContactData.firstName')
                        .valid &&
                      contactsForm.get('shippingNewContactData.firstName').touched
                    "
                    class="defaultMessage"
                    role="alert"
                    aria-live="assertive"
                    >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                  </span>
                </div>
  
                <div
                  class="
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                    doubleLineContainer
                  "
                >
                  <label for="formLastNameShipping" class="Fields-label"
                    >{{ "accountRegistration.contactsInformation.lastName_label" | cxTranslate }}
                  </label>
                  <input
                    id="formLastNameShipping"
                    name="lastName"
                    data-valid="valid_facility"
                    type="text"
                    class="Fields-input"
                    formControlName="lastName"
                    autocomplete="off"
                    data-di-id="#formLastNameShipping"
                  />
  
                  <span
                    *ngIf="
                      !!contactsForm.get('shippingNewContactData.lastName')
                        .value &&
                      !contactsForm.get('shippingNewContactData.lastName')
                        .valid &&
                      contactsForm.get('shippingNewContactData.lastName').touched
                    "
                    class="errorMessage"
                    >{{ "accountRegistration.special_validation_msg" | cxTranslate }}</span
                  >
                  <span
                    *ngIf="
                      contactsForm.get('shippingNewContactData.lastName').errors
                        ?.required &&
                      !contactsForm.get('shippingNewContactData.lastName')
                        .valid &&
                      contactsForm.get('shippingNewContactData.lastName').touched
                    "
                    class="defaultMessage"
                    role="alert"
                    aria-live="assertive"
                    >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                  </span>
                </div>
                <div
                  class="
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                    asses_dropdown
                  "
                >
                  <label
                    for="formTitleShip"
                    id="formTitleShipLabel"
                    class="Fields-label"
                    >{{ "accountRegistration.contactsInformation.title_label" | cxTranslate }}</label
                  >
                  <div class="">
                    <div class="">
                      <ng-select
                        name="title"
                        [items]="contactTitle"
                        [searchable]="false"
                        [clearable]="false"
                        bindLabel="name"
                        bindValue="code"
                        placeholder="Please select"
                        formControlName="title"
                        class="dropdown-credit"
                      ></ng-select>
                    </div>
                    <span
                      *ngIf="
                        contactsForm.get('shippingNewContactData.title').errors
                          ?.required &&
                        !contactsForm.get('shippingNewContactData.title').valid &&
                        contactsForm.get('shippingNewContactData.title').touched
                      "
                      class="errorMessage drop-downs"
                      role="alert"
                      aria-live="assertive"
                      >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                    </span>
                  </div>
                </div>
  
                <div
                  class="
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                    asses_dropdown
                  "
                >
                  <label
                    for="formUserRoleShip"
                    id="formUserRoleShipLabel"
                    class="Fields-label"
                    >{{ "accountRegistration.contactsInformation.role_label" | cxTranslate }}</label
                  >
                  <div class="">
                    <div class="">
                      <ng-select
                        name="role"
                        [items]="contactRole"
                        [searchable]="false"
                        [clearable]="false"
                        bindLabel="name"
                        bindValue="code"
                        placeholder="Please select"
                        formControlName="role"
                        class="dropdown-credit"
                      ></ng-select>
                    </div>
                    <span
                      *ngIf="
                        contactsForm.get('shippingNewContactData.role').errors
                          ?.required &&
                        !contactsForm.get('shippingNewContactData.role').valid &&
                        contactsForm.get('shippingNewContactData.role').touched
                      "
                      class="errorMessage drop-downs"
                      role="alert"
                      aria-live="assertive"
                      >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                    </span>
                  </div>
                </div>
  
                <div
                  class="
                    container
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                  "
                >
                  <label
                    for="preferredContactShippingg"
                    id="preferredContactShippinggLabel"
                    class="Fields-label"
                    >{{ "accountRegistration.contactsInformation.preferred_contact_label" | cxTranslate }}</label
                  >
                  <div class="" id="preferredContactEmailInvoices">
                    <label
                      for="preferredContactEmailShipping"
                      class="Fields-label mt0 res_lab"
                    >
                      {{ "accountRegistration.form.email.label" | cxTranslate }}
                    </label>
                    <div
                      class="
                        custom-control custom-radio custom-control-inline
                        radio_grp
                        label-location
                        ptl
                      "
                    >
                      <input
                        type="radio"
                        id="preferredEmailShipping"
                        name="preferredContactMethod3"
                        class="custom-control-input"
                        [value]="preferredContactMethod[0]"
                        formControlName="preferredContactMethod3"
                      />
                      <label
                        class="custom-control-label secloct"
                        for="preferredEmailShipping"
                      >
                      </label>
                      <div style="display: inline">
                        <input
                          id="primaryEmailShipp"
                          name="email"
                          data-valid="valid_mail"
                          type="text"
                          class="Fields-input contact-email"
                          data-view="newemail"
                          formControlName="email"
                          data-di-id="primaryEmailShipp"
                        />
                        <span
                          *ngIf="                          
                            !!contactsForm.get('shippingNewContactData.email')
                              .value &&
                            !contactsForm.get('shippingNewContactData.email')
                              .valid &&
                            contactsForm.get('shippingNewContactData.email')
                              .touched
                          "
                          class="errorMessage contacts"
                        >
                          {{ "accountRegistration.form.email.email_validation_msg" | cxTranslate }}
                        </span>
                        <span
                          *ngIf="
                            contactsForm.get('shippingNewContactData.email')
                              .errors?.required &&
                            !contactsForm.get('shippingNewContactData.email')
                              .valid &&
                            contactsForm.get('shippingNewContactData.email')
                              .touched
                          "
                          class="errorMessage contacts"
                          >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="" id="preferredContactFaxShipping">
                    <label
                      for="preferredContactFaxShipping"
                      class="Fields-label mt0 res_lab"
                    >
                      {{ "accountRegistration.contactsInformation.fax_label" | cxTranslate }}
                    </label>
                    <div
                      class="
                        custom-control custom-radio custom-control-inline
                        radio_grp
                        label-location
                        ptl
                      "
                    >
                      <input
                        type="radio"
                        id="preferredFaxShipping"
                        name="preferredContactMethod3"
                        class="custom-control-input"
                        [value]="preferredContactMethod[1]"
                        formControlName="preferredContactMethod3"
                      />
                      <label
                        class="custom-control-label secloct"
                        for="preferredFaxShipping"
                      >
                      </label>
                      <div style="display: inline">
                        <input
                          id="preferredFaxShipp"
                          name="fax"
                          data-valid="valid_fax"
                          placeholder="xxx-xxx-xxxx"
                          type="text"
                          class="Fields-input contact-email"
                          data-view="newfax"
                          formControlName="fax"
                          maxlength="12"
                          appPhoneMask
                          data-di-id="preferredFaxShipp"
                        />
                        <span
                          *ngIf="                          
                            !!contactsForm.get('shippingNewContactData.fax')
                              .value &&
                            !contactsForm.get('shippingNewContactData.fax')
                              .valid &&
                            contactsForm.get('shippingNewContactData.fax').touched
                          "
                          class="errorMessage contacts"
                        >
                        {{ "accountRegistration.form.office_fax.fax_validation_msg" | cxTranslate }}
                        </span>
                        <span
                          *ngIf="
                            contactsForm.get('shippingNewContactData.fax').errors
                              ?.required &&
                            !contactsForm.get('shippingNewContactData.fax')
                              .valid &&
                            contactsForm.get('shippingNewContactData.fax').touched
                          "
                          class="errorMessage contacts"
                          >{{ "accountRegistration.requiredMsg" | cxTranslate }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                  <label for="shippingPhone" class="Fields-label"
                    >{{ "accountRegistration.form.phone.label" | cxTranslate }}<span>{{ "accountRegistration.optional_tag" | cxTranslate }}</span></label
                  >
                  <input
                    id="shippingPhone"
                    name="phone"
                    data-valid="valid_phone"
                    placeholder="xxx-xxx-xxxx"
                    type="text"
                    maxlength="12"
                    appPhoneMask
                    class="Fields-input phone-no-mask field-optional"
                    formControlName="phone"
                    data-di-id="shippingPhone"
                  />
  
                  <span
                    class="errorMessage"
                    *ngIf="
                      !!contactsForm.get('shippingNewContactData.phone').value &&
                      !contactsForm.get('shippingNewContactData.phone').valid &&
                      contactsForm.get('shippingNewContactData.phone').touched
                    "
                    >{{ "accountRegistration.form.phone.ph_validation_msg" | cxTranslate }}</span
                  >
                </div>
              </div>
            </div>
          </div> -->

              <!-- Other New Section Ends -->
              <hr class="Fields-container-line billingPage" />
              <div class="invoice-btngrps">
                <button type="button" (click)="back()" class="btn-secondary" data-di-id="di-id-7a6cb2cd-cb37948a">
                  {{ "accountRegistration.form.back_button" | cxTranslate }}
                </button>
                <button type="submit" *ngIf="deaValueValidation=='Valid' && deaValueValidationforHIN=='Valid'"
                  class="btn-primary" data-di-id="di-id-7a6cb2cd-cb37948a">
                  {{ "accountRegistration.form.submit_button" | cxTranslate }}
                </button>
                <button type="submit" *ngIf="deaValueValidation=='notValid' || deaValueValidationforHIN=='notValid'"
                  disabled class="btn-primary" data-di-id="di-id-7a6cb2cd-cb37948a">
                  {{ "accountRegistration.form.submit_button" | cxTranslate }}
                </button>
              </div>
            </div>
          </form>
        </div>


      </div>
    </div>


  </div>
  <div class="col-xs-12 col-sm-12 col-md-4 needCls needCls2 Notify-Msg" [innerHTML]="(finalNeedAss | async)?.content"></div>
</div>